<template>
<div v-if="fights.length > 0">
  <h3 class="!mt-0 px-2.5 xl:px-0">Kursy - oferta na {{galaName}}</h3>
  <div v-if="window.size.desktop" class="border-[1px] border-zt-light rounded-zt">
    <div class="grid grid-cols-10 gap-x-2 px-2 text-center font-semibold bg-zt-light-full border-b-[1px] border-zt-light
     text-xs h-[41px] items-center xl:px-[18px]">
      <div class="col-span-8 my-2 text-left">
        <span class="ml-[10%]">Walka</span>
      </div>
      <div class="my-2">1</div>
      <div class="my-2">2</div>
    </div>
    <div class="grid grid-cols-10 h-[52px] py-1 gap-x-2 px-2 text-center bg-zt-light-opacity border-b-[1px] border-zt-light items-center xl:px-[18px]" v-for="(fight, index) in fights.slice(0, fightsToShow)">
      <div class="min-w-0 flex col-span-8 flex-col gap-0.5 flex-1 text-xs font-light text-left">
        <span class="whitespace-nowrap overflow-hidden text-ellipsis">{{ fight.fighter1_name }}</span>
        <span class="whitespace-nowrap overflow-hidden text-ellipsis">{{ fight.fighter2_name }}</span>
      </div>
      <div class="odd-button zt-hover font-normal" @click="fightOddClick(index + 1, 1)"
           :class="{'!bg-zt-light' : isOddSelected(index + 1, 1)}">{{ fight.fighter1_odd }}</div>
      <div class="odd-button zt-hover font-normal" @click="fightOddClick(index+1, 2)"
           :class="{'!bg-zt-light' : isOddSelected(index + 1, 2)}">{{ fight.fighter2_odd }}</div>
    </div>
    <div v-if="fightsToShow < fights.length" class="grid grid-cols-7 gap-x-2 gap-y-1 px-16 text-center bg-zt-light-opacity
        border-b border-zt-light">
      <div class="col-span-7 text-center py-4 uppercase text-xs underline text-zt-more">
        <span class="zt-hover cursor-pointer" @click="fightsToShow = fights.length">Pokaż wszystkie walki</span>
      </div>
    </div>
    <div class="grid grid-cols-6 gap-x-2 gap-y-1 px-2 text-center bg-zt-light-opacity items-center py-2 xl:font-semibold xl:px-[18px]">
      <div class="col-span-2 flex flex-nowrap justify-center items-center h-12 text-2xl my-2">
        <input type="text" min="0" class="w-[90%] h-full text-center !text-lg !font-semibold"
               placeholder="200" maxlength="10" v-model="stake" step="0.01" pattern="^[0-9]*[.,]?[0-9]{0,2}$" oninput="validity.valid || (value=this.value.slice(0,-1));"/>
        <span class="ml-2 !text-lg">PLN</span>
      </div>
      <div class="col-span-2 my-2 text-lg text-left mx-auto flex flex-nowrap items-center justify-center">
        Kurs całkowity: <div class="bg-zt-light ml-1 rounded-zt py-1 px-2 !min-w-[50px] text-center">{{ calculatedOdds }}</div>
      </div>
      <div class="col-span-2 my-2 flex items-center flex-nowrap whitespace-nowrap text-lg text-left ml-auto">Do wygrania:
        <div class="bg-[#38AE00] min-w-[70px] text-center rounded-zt py-1 px-2 ml-1 max-w-[146px] overflow-ellipsis overflow-hidden whitespace-nowrap">
          {{ possibleWin }} PLN
        </div>
      </div>
    </div>
    <div class="w-full rounded-t-zt text-center bg-zt-light-full border-t-[1px] border-zt-light">
      <div class="flex text-[20px] py-3.5 gap-x-4 items-center justify-center px-[64px]">
        <div class="text-base font-medium" v-html="bottomText"></div>
        <div @click="window.open(bonusLink, '_blank')" class="flex items-center">
            <span class="zt-button cursor-pointer zt-hover w-full px-4 uppercase !font-semibold">Odbierz kod promocyjny</span>
        </div>
      </div>
    </div>
  </div>
  <div class="rounded-zt border-[1px] border-zt-light" v-else>
    <div class="w-full flex items-center text-xs font-semibold py-2 bg-zt-light-full border-b-[1px] h-10 border-zt-light">
			<div class="min-w-0 flex-col gap-0.5 flex-1">
				<span class="pl-[60px]">Walka</span>
			</div>
			<div class="flex gap-4 text-center pl-5 pr-2">
				<div class="zt-hover w-[66px]">
					<span class="text-center">1</span>
				</div>
				<div class="zt-hover w-[66px]">
					<span class="text-center">2</span>
				</div>
			</div>
		</div>
    <div class="h-[50px] flex items-center pl-2 pr-2.5 bg-zt-light-opacity border-b border-zt-light" v-for="(fight, index) in fights.slice(0, fightsToShow)">
      <div class="min-w-0 flex flex-col gap-0.5 flex-1 text-xs font-light">
        <span class="whitespace-nowrap overflow-hidden text-ellipsis">{{ fight.fighter1_name }}</span>
        <span class="whitespace-nowrap overflow-hidden text-ellipsis">{{ fight.fighter2_name }}</span>
      </div>
      <div class="flex gap-4 ml-5">
        <div class="odd-button zt-hover w-[58px] h-[30px] " @click="fightOddClick(index + 1, 1)"
           :class="[ isOddSelected(index + 1, 1) ? ['!bg-zt-light'] : '']">
          <span class="text-center">{{ fight.fighter1_odd }}</span>
        </div>
        <div class="odd-button zt-hover w-[58px] h-[30px]" @click="fightOddClick(index + 1, 2)"
            :class="[ isOddSelected(index + 1, 2) ? ['!bg-zt-light'] : '']">
          <span class="text-center">{{ fight.fighter2_odd }}</span>
        </div>
      </div>
    </div>
    <div v-if="fightsToShow < fights.length" class="px-16 text-center bg-zt-light-opacity border-b border-zt-light">
      <div class="text-center py-4 uppercase text-xs cursor-pointer zt-hover text-zt-more underline"
           @click="fightsToShow = fights.length">Pokaż wszystkie walki</div>
    </div>
    <div class="bg-zt-light-opacity">
      <div class="flex py-4 px-2 gap-x-3 items-center text-center text-xs font-semibold">
        <div class="!h-[31px] min-w-[87px] max-w-[160px] flex items-center mx-auto">
          <input type="text" min="0" class="text-center !h-[34px] !leading-1 !text-sm !min-h-0 w-[90%] !font-semibold"
                 placeholder="200" maxlength="15" v-model="stake" step="0.01" pattern="^[0-9]*[.,]?[0-9]{0,2}$" oninput="validity.valid || (value=this.value.slice(0,-1));"/>
          <span class="flex-none text-sm ml-2">PLN</span>
        </div>
      </div>
      <div class="min-w-[50px] flex-grow pb-2 text-sm font-semibold mx-auto text-center flex items-center">
        <div class="h-[34px] w-full flex items-center justify-center">
          Kurs całkowity: <div class="bg-zt-light ml-1 rounded-zt py-1 px-2 !min-w-[50px] text-center">{{ calculatedOdds }}</div>
        </div>
      </div>
      <div class="min-w-[140px] mt-2 mb-4 text-sm text-center flex font-semibold">
        <div class="mx-auto flex items-center">
          <span>Do wygrania:</span>
          <div class="h-[34px] flex min-w-[80px] max-w-full justify-center items-center font-semibold ml-1 py-1 px-3 bg-[#38AE00] rounded-zt">
            <span class=" overflow-ellipsis overflow-hidden whitespace-nowrap">{{ possibleWin }} PLN</span>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 py-2.5 pl-2 pr-[18px] items-center gap-x-2.5 text-center bg-zt-light-full border-t border-zt-light">
        <span class="col-span-2 text-md font-medium" v-html="bottomText"></span>
        <div @click="window.open(bonusLink, '_blank')"  class=" zt-button col-span-2 mx-auto h-[45px] w-[254px] text-sm flex
       items-center whitespace-pre-wrap uppercase mt-4 font-semibold">
          <span class="mx-auto">Odbierz kod promocyjny</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'BetsCalculator',
  inject: ['WP'],
  data() {
    this.data = null;
    return {
      fights: [],
      galaName: '',
      galaDate: '',
      fightsToShow: 15,
      stripColor: '',
      stripTextColor: '',
      ticketColor: '',
      ticketTextColor: '',
      bottomText: '',
      bonusLink: '',
      bookmaker: '',
      stake: '',
      selectedOdds: [],
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    calculatedOdds() {
      if (this.selectedOdds.length > 0) {
        let calculatedOdd = 1;
        this.selectedOdds.forEach((fight) => {
          let selectedFight = this.fights[fight.fightNumber - 1];
          if (fight.oddNumber === 1) {
            calculatedOdd = calculatedOdd * Number(selectedFight.fighter1_odd);
          } else {
            calculatedOdd = calculatedOdd * Number(selectedFight.fighter2_odd);
          }
        });
        return calculatedOdd.toFixed(2);
      } else {
        return 0;
      }
    },
    possibleWin() {
      let odds = Number(this.stake);
      if (!isNaN(odds) && this.selectedOdds.length > 0) {
        if (Number(this.stake) !== 0) {
          return (0.88 * this.calculatedOdds * parseFloat(this.stake).toFixed(2)).toFixed(2);
        } else {
          return (0.88 * this.calculatedOdds * 200).toFixed(2);
        }
      } else {
        return 0.00;
      }
    },
  },
  methods: {
    getData() {
      axios
      .get('/wp-json/acf/v3/posts/'+WP.id+'?_fields=acf.odds_type,acf.gala_date,acf.odds_bookmaker,acf.odds_bottom_text,acf.odds_bookmaker_link&acf_format=standard')
        .then(response => {
          this.galaName = response.data.acf['odds_type'];
          this.galaDate = response.data.acf['gala_date'];
          this.bookmaker = response.data.acf['odds_bookmaker']?.toLowerCase();
          this.bottomText = response.data.acf['odds_bottom_text'];
          this.bonusLink = response.data.acf['odds_bookmaker_link'];
          this.getFights();
          this.setColors();
        });
    },
    getFights() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_gala_fight_odds',
          gala_name: this.galaName,
          gala_date: this.galaDate,
        })
        .then(response => {
					this.fights = response.data.data;
          if (this.fights.length > 0) {
            this.fights = this.fights.filter(el => {
             return el.added_manually == 0;
            });
          }
        });
    },
    setColors() {
      if (this.bookmaker === 'fortuna') {
        this.stripColor = 'bg-[#FEDE00]';
        this.stripTextColor = 'text-[#000000]';
        this.ticketColor = 'bg-[#D2161E]';
        this.ticketTextColor = 'text-[#FFFFFF]';
      } else if (this.bookmaker === 'betclic') {
        this.stripColor = 'bg-[#D2161E]';
        this.stripTextColor = 'text-[#FFFFFF]';
        this.ticketColor = 'bg-[#E9B500]';
        this.ticketTextColor = 'text-[#000000]';
      } else if (this.bookmaker === 'lvbet') {
        this.stripColor = 'bg-[#0E0D12]';
        this.stripTextColor = 'text-[#FFFFFF]';
        this.ticketColor = 'bg-[#FFFFFF]';
        this.ticketTextColor = 'text-[#000000]';
      }
    },
    fightOddClick(fightNumber, oddNumber) {
      let index = this.selectedOdds.findIndex((e) => {
        return e.fightNumber === fightNumber;
      })
      if (index === -1) {
        this.selectedOdds.push({fightNumber: fightNumber, oddNumber: oddNumber});
      } else {
        if (this.selectedOdds[index].oddNumber === oddNumber) {
          this.selectedOdds.splice(index, 1);
        } else {
          this.selectedOdds[index].oddNumber = oddNumber;
        }
      }
    },
    isOddSelected(fightNumber, oddNumber) {
      let index = this.selectedOdds.findIndex((e) => {
        return e.fightNumber === fightNumber;
      });
      if (index === -1) {
        return false;
      } else {
        return this.selectedOdds[index].oddNumber === oddNumber;
      }
    }
  },
}
</script>

<style scoped>

.odd-button {
  @apply text-sm transition-colors rounded-zt flex justify-center items-center cursor-pointer h-[24px] mx-auto
  bg-transparent border-zt-light border-[1px] xl:w-[52px] xl:font-normal xl:text-sm xl:py-0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

input:focus::placeholder {
    color: transparent;
}

@media (max-width: 1280px) {
    input::placeholder {
      color: white;
    }
  }
</style>